import {
    JSMOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { ExperimentView, experiments } from "@/utils/experiment";

import {
    FreeForThreeAgentsText,
    Headings,
    WelcomeBackText,
    YourPlanIncludesText
} from "../components";

const ExistingUserContent = () => {
    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<FreeForThreeAgentsText />}
            />
            <SiteActivation />
        </>
    );
};

const ExistingUserContentLofi = () => {
    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<YourPlanIncludesText />}
            />
            <SiteActivation />
        </>
    );
};

export const ExistingUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <ExistingUserContentLofi />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <ExistingUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
